import React from 'react';
import { Icon, IconProps } from '~web/view/components/ui/icon.component';

export const ExitIcon: React.FunctionComponent<IconProps> = ({
  width = 32,
  height = 32,
  ...rest
}) => (
  <Icon width={width} height={height} viewBoxWidth={32} viewBoxHeight={32} {...rest}>
    <path d="M18.5467 20.7867L16.6667 22.6667L10 16L16.6667 9.33333L18.5467 11.2133L15.1067 14.6667H28V17.3333H15.1067L18.5467 20.7867ZM6.66667 4H25.3333C26.8133 4 28 5.2 28 6.66667V12H25.3333V6.66667H6.66667V25.3333H25.3333V20H28V25.3333C28 26.8 26.8133 28 25.3333 28H6.66667C5.2 28 4 26.8 4 25.3333V6.66667C4 5.2 5.2 4 6.66667 4Z" />
  </Icon>
);



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/view/components/ui/icon/exit.icon.tsx